
export const mixin = {
  data: function () {
    return {

    }
  },
  props: {
    openid: { // 微信
      type: String,
      default: function () {
        return '';
      }
    },
    type: { // userName or departmentName
      type: String,
      default: function () {
        return 'userName';
      }
    }
  },
  computed:{

  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/common/wx-show-data/index.js